import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { GisDataModel } from '@bo-client/shared/models/gisData';
import { CreateFormsService } from '@bo-client/activation-management/shared/forms/create-forms.service';
import { ValidatorsService } from '@bo-client/shared/forms/validators.service';
import { MetaService } from '@bo-client/core/api/meta-service';
import { Subject } from 'rxjs';
import { ContactData } from '@bo-client/shared/models/contactData';
import { ContactDataForm } from '@bo-client/shared/models/contactDataDto';
import { initContactDataSalutationSubscription } from '@bo-client/shared/forms/contact-form/contact-data-salutation.subscription';

@Component({
  selector: 'app-filiation-form',
  templateUrl: './filiation-form.component.html',
  styleUrls: ['./filiation-form.component.scss']
})
export class FiliationFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() inputFormArray: FormArray;
  @Input() selectedGisData: GisDataModel;
  @Input() id: number;
  @Input() disableContractPartner = false;
  @Input() canUpdate = false;
  public differentContractPartner = false;

  constructor(
    private createFormsService: CreateFormsService,
    public validatorsService: ValidatorsService,
    public metaService: MetaService
  ) {
    // Empty
  }

  ngOnInit(): void {
    this.initFormArray();
  }

  private initFormArray() {
    const listFiliation: ContactData[] = (this.inputFormArray as FormArray).value;
    if (!!listFiliation.length) {
      this.differentContractPartner = !!listFiliation[1]?.salutation;
      for (let i = 0; i < listFiliation.length; i++) {
        const salutation = (this.inputFormArray as FormArray).controls[i].get('salutation');
        salutation.setValidators([Validators.required]);

        initContactDataSalutationSubscription(
          this.inputFormArray.controls[i] as ContactDataForm,
          this.metaService,
          this.ngUnsubscribe
        );
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initFormArray();
  }

  onToggle(event: any) {
    this.differentContractPartner = event.checked;
    if (this.differentContractPartner) {
      this.createFiliationData();
    } else {
      this.deleteFiliationData();
    }
  }

  createFiliationData() {
    const newItem: FormGroup = this.createFormsService.createContactDataForm({});
    newItem.get('salutation').setValidators([Validators.required]);
    initContactDataSalutationSubscription(newItem as ContactDataForm, this.metaService, this.ngUnsubscribe);
    this.inputFormArray.push(newItem);
  }

  deleteFiliationData() {
    this.inputFormArray.removeAt(1);
  }

  copyAddress() {
    if (this.selectedGisData) {
      this.inputFormArray.controls[0].patchValue({
        street: this.selectedGisData.street,
        streetNo: this.selectedGisData.houseNo,
        streetNoAddition: this.selectedGisData.houseNoAddition,
        uniqueCoId: this.selectedGisData.uniqueCoId,
        zipCode: this.selectedGisData.zipCode,
        city: this.selectedGisData.city
      });
    }
  }

  private readonly ngUnsubscribe = new Subject<void>();
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
